module.exports = __webpack_public_path__ + "img/pay-quick.63dcfb5e.png";